export default __webpack_public_path__ + "svg/calendar/2025/1/mayo.svg?336b3b6f";